/* tslint:disable */
/* eslint-disable */
export enum ProjectSettingRateType {
    Text = 0,
    Number = 1,
    Decimal = 2,
    Bool = 3,
    Percentage = 4
}